import React from 'react';

class FbLoginButton extends React.Component {
  componentDidMount() {
    window.FB.XFBML.parse(this.fBbuttonDiv);
  }

  render() {
    return (
      <div
        style={{
          height: '54px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        ref={(e) => {
          this.fBbuttonDiv = e;
        }}
        dangerouslySetInnerHTML={{
          __html: `
            <fb:login-button
              style="width: 100%; max-width: 400px;"
              width="100%"
              size="large"
              button-type="continue_with"
              layout="rounded"
              auto-logout-link="false"
              use-continue-as="true"
              scope="public_profile,email"
            >
              Connect with Facebook
            </fb:login-button>
          `,
        }}
      ></div>
    );
  }
}

export default FbLoginButton;



// WEBPACK FOOTER //
// ./app/components/FbLoginButton/index.js